import type { TranslateFn } from '@eliadmin/core/src/hooks/use-translations';
import { CiGlobe } from 'react-icons/ci';
import { FaTwitter, FaLinkedin, FaInstagram, FaGithub, FaFacebook, FaTiktok } from 'react-icons/fa';
import { RiTwitterXFill } from 'react-icons/ri';

export const enabledSocials = ['facebook', 'instagram', 'linkedin', 'tiktok', 'twitter'];

const socialsMapping = (t: TranslateFn) => [
  {
    name: 'www',
    label: t('www'),
    icon: <CiGlobe size={20} />,
  },
  {
    name: 'twitter',
    label: t('X'),
    icon: <RiTwitterXFill size={20} />, // Replace with the desired icon component
  },
  {
    name: 'linkedin',
    label: t('LinkedIn'),
    icon: <FaLinkedin size={20} />, // Replace with the desired icon component
  },
  {
    name: 'instagram',
    label: t('Instagram'),
    icon: <FaInstagram size={20} />, // Replace with the desired icon component
  },
  {
    name: 'github',
    label: t('GitHub'),
    icon: <FaGithub size={20} />, // Replace with the desired icon component
  },
  {
    name: 'facebook',
    label: t('Facebook'),
    icon: <FaFacebook size={20} />, // Replace with the desired icon component
  },
  {
    name: 'tiktok',
    label: t('TikTok'),
    icon: <FaTiktok size={20} />, // Replace with the desired icon component
  },
];

export const getSocialByName = (name: string, t: TranslateFn) => {
  return socialsMapping(t).find(s => s.name === name);
};
